import { defineComponent, computed, withDirectives, openBlock, createElementBlock, mergeProps, unref, isRef, vModelText } from "vue";
import { useFormControl } from "../../composables/useFormControl.js";
const _hoisted_1 = ["disabled"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Textarea",
  props: {
    size: { default: "sm" },
    disabled: { type: Boolean, default: false },
    modelValue: {},
    rounded: {}
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const { size, model, hasError } = useFormControl(props, emit);
    const textareaClasses = computed(() => {
      return [
        "textarea",
        `textarea--${size.value}`,
        {
          "has-error": hasError?.value ?? false,
          disabled: props.disabled
        }
      ];
    });
    const textareaStyles = computed(() => {
      const roundedValue = props.rounded?.trim();
      if (!roundedValue) {
        return {};
      }
      if (roundedValue.startsWith("var(") || roundedValue === "0" || /^\d/.test(roundedValue)) {
        return { "--textarea-radius": roundedValue };
      }
      return { "--textarea-radius": `var(--radius-${roundedValue})` };
    });
    return (_ctx, _cache) => {
      return withDirectives((openBlock(), createElementBlock("textarea", mergeProps({
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(model) ? model.value = $event : null),
        class: unref(textareaClasses),
        style: unref(textareaStyles),
        disabled: __props.disabled
      }, _ctx.$attrs), null, 16, _hoisted_1)), [
        [vModelText, unref(model)]
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Textarea.vue2.js.map
